export enum SuggestionPriority {
    NO_PRIORITY = 'NO_PRIORITY',
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    HIGHEST = 'HIGHEST',
}